/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function AddIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "add", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 5V20M5 12.5H20", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(AddIcon);
export default ForwardRef;
//# sourceMappingURL=addIcon.js.map